import { cleanText } from "./ident-utils.js";

export const ON_WATCH_STORAGE_KEY = "actracker.onWatchSnapshot.v1";

function clonePayload(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return {};
  }
  try {
    return JSON.parse(JSON.stringify(payload));
  } catch (_error) {
    const copy = {};
    Object.keys(payload).forEach((key) => {
      const value = payload[key];
      if (value === null || value === undefined) {
        copy[key] = value;
        return;
      }
      if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
        copy[key] = value;
      }
    });
    return copy;
  }
}

export function normaliseWatchSnapshotEntry(raw) {
  if (!raw || typeof raw !== "object") {
    return null;
  }
  const onWatch = Boolean(raw.onWatch ?? raw.watch_on ?? raw.on_watch);
  const reason = cleanText(raw.reason ?? raw.watch_reason) || null;
  const source = cleanText(raw.source ?? raw.watch_source) || null;
  const scheduledDepartureAt =
    raw.scheduledDepartureAt ?? raw.watch_scheduled_departure ?? null;
  const scheduledContext = cleanText(raw.scheduledContext ?? raw.watch_scheduled_context) || null;
  const triggeredAt = raw.triggeredAt ?? raw.watch_triggered_at ?? null;
  const updatedAt = raw.updatedAt ?? raw.watch_updated_at ?? null;
  const createdAt = raw.createdAt ?? raw.watch_created_at ?? null;
  const payloadCandidate =
    (raw.payload && typeof raw.payload === "object" && !Array.isArray(raw.payload))
      ? raw.payload
      : (raw.watch_payload && typeof raw.watch_payload === "object" && !Array.isArray(raw.watch_payload))
      ? raw.watch_payload
      : {};
  const payload = clonePayload(payloadCandidate);
  const hasPayload = Object.keys(payload).length > 0;
  const hasMeaningfulDetails =
    onWatch ||
    Boolean(reason) ||
    Boolean(scheduledDepartureAt) ||
    Boolean(scheduledContext) ||
    Boolean(triggeredAt) ||
    hasPayload;
  if (!hasMeaningfulDetails) {
    return null;
  }
  return {
    onWatch,
    reason,
    source,
    scheduledDepartureAt: scheduledDepartureAt || null,
    scheduledContext,
    triggeredAt: triggeredAt || null,
    payload,
    updatedAt: updatedAt || null,
    createdAt: createdAt || null,
  };
}

export function serialiseWatchSnapshotMap(map) {
  if (!map || typeof map.forEach !== "function") {
    return [];
  }
  const entries = [];
  map.forEach((value, key) => {
    const numericId = Number(key);
    if (!Number.isFinite(numericId) || numericId <= 0) {
      return;
    }
    const entry = normaliseWatchSnapshotEntry(value);
    if (!entry) {
      return;
    }
    entries.push({ id: numericId, ...entry });
  });
  return entries;
}

export function buildWatchStoragePayload(map) {
  const entries = serialiseWatchSnapshotMap(map);
  if (!entries.length) {
    return null;
  }
  return {
    savedAt: new Date().toISOString(),
    entries,
  };
}

export function parseStoredWatchEntries(raw) {
  if (raw === null || raw === undefined || raw === "") {
    return { entries: [], error: null };
  }
  let parsed;
  try {
    parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
  } catch (error) {
    return { entries: [], error };
  }
  const list = Array.isArray(parsed?.entries)
    ? parsed.entries
    : Array.isArray(parsed)
    ? parsed
    : [];
  const entries = [];
  list.forEach((item) => {
    const numericId = Number(item?.id);
    if (!Number.isFinite(numericId) || numericId <= 0) {
      return;
    }
    const entry = normaliseWatchSnapshotEntry(item);
    if (entry) {
      entries.push([numericId, entry]);
    }
  });
  return { entries, error: null };
}
